import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "8b0c453a-e5af-43fd-b2c5-b37750ca98db",
  publicId: "3",
  name: "Acoustic treatment - absorption, reflection, and diffusion",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
